// extracted by mini-css-extract-plugin
module.exports = {"CreateGist":"CreateGist_CreateGist__xOYIE"};